import React from 'react';
import css from './CreditsSection.css';
import classNames from 'classnames';
import {
    IconMailCheckL,
    IconPresentL,
    IconTeamL,
    IconEyeHideL,
    IconReplaceL,
    IconAnonymousL,
    IconRocketL,
} from '../../../../icons';
import { tableItems } from './tableItems';

const icons = [
    <IconMailCheckL />,
    <IconPresentL />,
    <IconTeamL />,
    <IconEyeHideL />,
    <IconAnonymousL />,
    <IconRocketL />,
];

export default () => {
    return (
        <section className={css.root}>
            <header>
                <h2 className={css.subHeading}>Transparenz</h2>
                <p className={css.heading}>Wie viele Credits brauche ich?</p>
                <p className={css.description}>
                    Du entscheidest selbst, wofür Du deine Credits einsetzt. In dieser Übersicht
                    siehst Du transparent, welche Funktionen wie viele Credits benötigen.
                </p>
            </header>

            <div className={css.table}>
                <div className={classNames(css.row, css.firstRow)}>
                    <p className={css.cell}>Funktion</p>
                    <p className={css.cell}>Credits</p>
                    <p className={css.cell}>Wann werden Credits benötigt?</p>
                    <p className={css.cell}>Hilfe-Artikel</p>
                </div>
                {tableItems.map(({ label, credits, description, link }, index) => (
                    <div className={css.row} key={index}>
                        <p className={css.cell}>
                            {icons[index]}
                            <span>{label}</span>
                        </p>
                        <p className={css.cell}>
                            <IconReplaceL />
                            <span>{credits} Credits</span>
                        </p>
                        <p className={css.cell}>
                            <span>{description}</span>
                        </p>
                        <p className={css.cell}>
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                Mehr erfahren
                            </a>
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
};
